import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { colors, fontStyles, spacing } from '../../styles';
import ToggleSwitch from '../ToggleSwitch';

interface NotificationToggleSectionProps {
  areAllEnabled: boolean;
  onToggleAll: () => void;
}

const NotificationToggleSection: React.FC<NotificationToggleSectionProps> = ({ areAllEnabled, onToggleAll }) => {
  const { t } = useTranslation();
  return (
    <div
      css={css`
        padding: ${spacing.deci};
        background-color: var(--card-background);
        border-radius: 8px;
        margin-bottom: ${spacing.hecto};
        border: 2px solid ${areAllEnabled ? colors.petrolBlue : 'transparent'};
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <div>
          <p
            css={css`
              ${fontStyles.cat};
              color: var(--text-color);
              margin: 0 0 ${spacing.micro} 0;
              font-weight: 500;
            `}
          >
            {t('notifications.enableAll')}
          </p>
          <p
            css={css`
              ${fontStyles.thinFlea};
              margin: 0;
              color: var(--secondary-text);
              opacity: 0.8;
              html[data-theme='dark'] & {
                color: ${colors.sugar};
                opacity: 0.7;
              }
            `}
          >
            {t('notifications.enableAllDescription')}
          </p>
        </div>
        <ToggleSwitch checked={areAllEnabled} onChange={onToggleAll} />
      </div>
    </div>
  );
};

export default NotificationToggleSection;
